'use client'

import { useEffect, useRef } from 'react'
import { motion, useMotionValue, useTransform } from 'framer-motion'

export default function MouseEffects() {
  const cursorRef = useRef<HTMLDivElement>(null)
  const mouseX = useMotionValue(0)
  const mouseY = useMotionValue(0)

  // 计算鼠标位置
  const cursorX = useTransform(mouseX, (value) => value - 16)
  const cursorY = useTransform(mouseY, (value) => value - 16)

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mouseX.set(e.clientX)
      mouseY.set(e.clientY)
    }

    const handleMouseEnter = () => {
      if (cursorRef.current) {
        cursorRef.current.style.opacity = '1'
        cursorRef.current.style.transform = 'scale(1)'
      }
    }

    const handleMouseLeave = () => {
      if (cursorRef.current) {
        cursorRef.current.style.opacity = '0'
        cursorRef.current.style.transform = 'scale(0.5)'
      }
    }

    // 添加事件监听
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseenter', handleMouseEnter)
    document.addEventListener('mouseleave', handleMouseLeave)

    // 为所有可交互元素添加效果
    const interactiveElements = document.querySelectorAll('a, button, [role="button"]')
    interactiveElements.forEach((element) => {
      element.addEventListener('mouseenter', () => {
        if (cursorRef.current) {
          cursorRef.current.style.transform = 'scale(1.5)'
          cursorRef.current.style.background = 'rgba(249, 115, 22, 0.3)'
        }
      })
      
      element.addEventListener('mouseleave', () => {
        if (cursorRef.current) {
          cursorRef.current.style.transform = 'scale(1)'
          cursorRef.current.style.background = 'rgba(249, 115, 22, 0.1)'
        }
      })
    })

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseenter', handleMouseEnter)
      document.removeEventListener('mouseleave', handleMouseLeave)
      
      interactiveElements.forEach((element) => {
        element.removeEventListener('mouseenter', () => {})
        element.removeEventListener('mouseleave', () => {})
      })
    }
  }, [])

  return (
    <>
      {/* 自定义鼠标光标 */}
      <motion.div
        ref={cursorRef}
        className="fixed w-8 h-8 rounded-full pointer-events-none z-50 mix-blend-difference"
        style={{
          x: cursorX,
          y: cursorY,
          background: 'rgba(249, 115, 22, 0.1)',
          border: '1px solid rgba(249, 115, 22, 0.5)',
          backdropFilter: 'blur(2px)',
          opacity: 0,
          transform: 'scale(0.5)',
          transition: 'all 0.1s ease-out'
        }}
      />
      
      {/* 鼠标轨迹效果 */}
      <motion.div
        className="fixed w-4 h-4 rounded-full pointer-events-none z-40"
        style={{
          x: useTransform(mouseX, (value) => value - 8),
          y: useTransform(mouseY, (value) => value - 8),
          background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, transparent 70%)',
          filter: 'blur(2px)'
        }}
      />
      
      {/* 鼠标光环效果 */}
      <motion.div
        className="fixed w-20 h-20 rounded-full pointer-events-none z-30"
        style={{
          x: useTransform(mouseX, (value) => value - 40),
          y: useTransform(mouseY, (value) => value - 40),
          background: 'radial-gradient(circle, rgba(249, 115, 22, 0.05) 0%, transparent 100%)',
          filter: 'blur(8px)'
        }}
      />
    </>
  )
}